import * as React from "react"
import { graphql, Link } from "gatsby"

import CardBlock  from "../components/card-block"
import Featured from "../components/featured"
import Layout from "../components/layout"
import Seo from "../components/seo"

const Index = ({ data, location }) => {
  const videos = data.videos.nodes;
  const featured = data.featured.nodes;
  const next = data.next.nodes;

  return (
    <Layout location={location} title="Latest Videos">
      <section id="videos">
        <h2 className="text-2xl font-normal leading-normal mt-0 mb-2" data-lcp-element="true">
          <span className="font-bold">Latest Videos</span>
          <span className="mx-2" aria-hidden="true">|</span>
          <Link
            to="/videos"
            className="inline-block"
            aria-label="View all videos"
          >
            All Videos
          </Link>
        </h2>
        <Featured featured={ featured } skipLazyLoading={true} />
        <CardBlock cardType="videos" posts={videos} location={location} eagerLoadFirstTwo={true} />
        <Featured featured={ next } skipLazyLoading={false} />
        <div className="grid grid-cols-1 gap-3 mt-2">
          <Link
            className="w-full text-center h-auto py-2 px-4 text-white text-base md:text-lg bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 font-medium shadow-md focus:outline-hidden transition-all duration-300 ease-in-out"
            to="/videos"
          >
            All Videos
          </Link>
        </div>
      </section>
    </Layout>
  )
}

export default Index

// Export Head component using Gatsby's built-in Head API
export const Head = ({ data }) => {
  // Create structured data for homepage
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Latest Videos",
    "description": "New releases from water-and-power.com",
    "url": data.site.siteMetadata.siteUrl,
    "isPartOf": {
      "@type": "WebSite",
      "name": data.site.siteMetadata.title,
      "url": data.site.siteMetadata.siteUrl,
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${data.site.siteMetadata.siteUrl}/search/?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": data.videos.nodes.map((video, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "url": `${data.site.siteMetadata.siteUrl}${video.fields.slug}`,
        "name": video.frontmatter.title
      }))
    }
  };

  return Seo({
    title: "Latest Videos",
    description: "New releases from water-and-power.com",
    canonicalUrl: data.site.siteMetadata.siteUrl,
    structuredData
  });
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    featured: allMarkdownRemark(
      filter: { video: { eq: true }, published: { eq: true }, featured: { eq: true }  },
      sort: {frontmatter: {publishDate: DESC}}
      limit: 6,
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          hero
          title
          vid
        }
      }
    }
    videos: allMarkdownRemark(
      filter: { video: { eq: true }, published: { eq: true },  },
      sort: {frontmatter: {publishDate: DESC}},
      limit: 4,
    ) {
      nodes {
        summary: excerpt(format: HTML, pruneLength: 200, truncate: true)
        fields {
          slug
        }
        frontmatter {
          girls
          hero
          premium_4k
          premium_lg
          premium_sm
          previewId
          related
          streamId
          tags
          title
          vid
        }
      }
    }
    next: allMarkdownRemark(
      filter: { video: { eq: true }, published: { eq: true },  },
      sort: {frontmatter: {publishDate: DESC}},
      limit: 18,
      skip: 4,
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          hero
          title
          vid
        }
      }
    }
  }
`
